import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useUsageStore } from '../store/usageStore';

const UsageBadge: React.FC = () => {
  const { usage, fetchUsage } = useUsageStore();

  useEffect(() => {
    fetchUsage();
  }, [fetchUsage]);

  if (!usage) return null;

  const planLabel = usage.tier.charAt(0).toUpperCase() + usage.tier.slice(1);
  const searchesText = usage.searches_limit === -1 ? '∞' : `${usage.searches_remaining}/${usage.searches_limit}`;
  const leadsText = usage.leads_limit === -1 ? '∞' : `${usage.leads_remaining}/${usage.leads_limit}`;

  return (
    <Link
      to="/dashboard"
      className="flex items-center gap-3 px-3 py-1.5 rounded-xl bg-slate-100 border border-slate-200 hover:bg-slate-200/80 transition-colors"
    >
      <span className="text-xs font-bold text-slate-600">{planLabel}</span>
      <span className="text-slate-400">•</span>
      <span className="text-xs font-medium text-slate-700">
        <span className="text-indigo-600">{searchesText}</span> searches
      </span>
      <span className="text-slate-400">•</span>
      <span className="text-xs font-medium text-slate-700">
        <span className="text-indigo-600">{leadsText}</span> leads
      </span>
    </Link>
  );
};

export default UsageBadge;
